<template>
	<transition 
			appear
			:appear-active-class="$_trnSctTabLyt_stylePageLayoutAnimation()">
		<template v-if="initialized_">
			<v-row no-gutters>
				<v-col>
					<!-- tab for mobile (dropdown) -->
					<template v-if="$_trnSctTabLyt_stateAppIsMobileScreen">
						<v-row no-gutters>
							<v-col>
								<v-toolbar color="transparent">
									<v-menu offset-y>
										<template v-slot:activator="{ on }">
											<v-btn	class="customVBtn"
													color="primary"
													dark
													icon
													v-on="on">
												<v-icon>
													keyboard_arrow_down
												</v-icon>
											</v-btn>
										</template>
										<v-list>
											<template v-for="(sectionVals, sectionKey, sectionIndex) in sortObject($_trnSctTabLyt_stateTrainingsModuleSections, 'order')">
												<template v-if="$_trnSctTabLyt_checkSectionStatus(sectionKey)">
													<v-list-item
															:key="sectionKey"
															@click="$_trnSctTabLyt_selectSection(sectionKey, sectionVals, sectionIndex)">
														<v-list-item-title
																v-html="$_trnSctTabLyt_langContentSectionTitle(sectionVals)" />
													</v-list-item>
												</template>
											</template>
										</v-list>
									</v-menu>
									<v-toolbar-title 
											class="subtitle-1"
											v-html="sectionTitle_" />
								</v-toolbar>
							</v-col>
						</v-row>
					</template>
					<v-row no-gutters>
						<!-- tab for web (vertical) -->
						<template v-if="!$_trnSctTabLyt_stateAppIsMobileScreen">
							<v-col cols="auto">
								<v-tabs v-model="sectionNumber_"
								
										class="customVTabs"
										vertical

										:background-color="$_trnSctTabLyt_styleSectionTabTabsBackgroundColor"
										:color="$_trnSctTabLyt_styleSectionTabTabsColor"
										:dark="$_trnSctTabLyt_styleSectionTabTabsDark"
										:hide-slider="$_trnSctTabLyt_styleSectionTabTabsHideSlider"
										:light="$_trnSctTabLyt_styleSectionTabTabsLight"
										:slider-color="$_trnSctTabLyt_styleSectionTabTabsSliderColor">
									<template v-for="(sectionVals, sectionKey) in sortObject($_trnSctTabLyt_stateTrainingsModuleSections, 'order')">
										<v-tab	:key="sectionKey"

												:disabled="!$_trnSctTabLyt_checkSectionStatus(sectionKey) || !$_trnSctTabLyt_checkPreviousSectionStatus(sectionKey, 'finished')"

												:dark="$_trnSctTabLyt_styleTabDark"
												:light="$_trnSctTabLyt_styleTabLight">
											<span	class="caption"
													v-html="$_trnSctTabLyt_langContentSectionTitle(sectionVals)" />
										</v-tab>
									</template>
								</v-tabs>
							</v-col>
						</template>
						<template v-if="!onLoading_">
							<v-spacer />
							<!-- tab content -->
							<v-col cols="11" md="8">
								<v-tabs-items
										class="customVTabs"
										v-model="sectionNumber_">
									<template v-for="(sectionVals, sectionKey, sectionIndex) in sortObject($_trnSctTabLyt_stateTrainingsModuleSections, 'order')">
										<v-tab-item :key="sectionIndex">
											<v-row class="customVRow" no-gutters>
												<v-col>
													<template v-if="sectionVals.title">
														<v-row justify="center">
															<v-col>
																<v-sheet
																		class="customVSheet"
																		pa-3 
																		:color="$_trnSctTabLyt_styleSectionTabHeaderSheetColor"
																		:dark="$_trnSctTabLyt_styleSectionTabHeaderSheetDark"
																		:elevation="$_trnSctTabLyt_styleSectionTabHeaderSheetElevation"
																		:light="$_trnSctTabLyt_styleSectionTabHeaderSheetLight">
																	<v-card color="transparent" flat>
																		<v-card-text class="center">
																			<center>
																				<span	class="headline"
																						v-html="$_trnSctTabLyt_langContentTitle(sectionVals)" />
																			</center>
																		</v-card-text>
																	</v-card>
																</v-sheet>
															</v-col>
														</v-row>
													</template>
													<v-row>
														<v-col>
															<v-sheet
																	class="customVSheet"
																	:color="$_trnSctTabLyt_styleSectionTabBodySheetColor"
																	:dark="$_trnSctTabLyt_styleSectionTabBodySheetDark"
																	:elevation="$_trnSctTabLyt_styleSectionTabBodySheetElevation"
																	:light="$_trnSctTabLyt_styleSectionTabBodySheetLight">
																<v-card	class="customVCard"
																		color="transparent"
																		flat>
																	<template v-if="sectionVals.bigImage">
																		<v-row>
																			<v-col>
																				<v-img	class="customVImg"
																						:src="$_trnSctTabLyt_styleContentBigImageUrl(sectionVals)" />
																			</v-col>
																		</v-row>
																	</template>
																	<template v-if="!isEmpty(sectionVals.video)">
																		<v-row>
																			<v-col>
																				<card-video
																						:contentKey="sectionKey"
																						:contents="$_trnSctTabLyt_stateTrainingsModuleSections"
																						:inits="inits"
																						@ended="$_trnSctTabLyt_completeSection(sectionKey)" />
																			</v-col>
																		</v-row>
																	</template>
																	<template v-if="!isEmpty(sectionVals.carousel)">
																		<v-row>
																			<v-col>
																				<card-carousel
																						:contentKey="sectionKey"
																						:contents="$_trnSctTabLyt_stateTrainingsModuleSections"
																						:inits="inits"
																						@ended="$_trnSctTabLyt_completeSection(sectionKey)" />
																			</v-col>
																		</v-row>
																	</template>
																	<v-row>
																		<template v-if="isObject(sectionVals.image)">
																			<v-col cols="12" md="4" class="center">
																				<v-img	class="customVImg"
																						:src="$_trnSctTabLyt_styleContentImageUrl(sectionVals)" />
																			</v-col>
																		</template>
																		<template v-if="sectionVals.text || sectionVals.actionButtons">
																			<v-col>
																				<template v-if="!isFalse($_trnSctTabLyt_langContentText(sectionVals))">
																					<v-row no-gutters>
																						<v-col>
																							<v-card-text>
																								<span	class="markdown"
																										v-html="marked($_trnSctTabLyt_langContentText(sectionVals))" />
																							</v-card-text>
																						</v-col>
																					</v-row>
																				</template>
																				<template v-if="sectionVals.actionButtons">
																					<v-row no-gutters>
																						<v-col>
																							<v-card-actions>
																								<v-row>
																									<template v-for="(actionButtonVals, actionButtonKey) in sortObject(sectionVals.actionButtons, 'order')">
																										<v-col :key="actionButtonKey">
																											<v-btn	class="customVBtn"
																													:block="$_trnSctTabLyt_styleSectionTabActionButtonBlock"
																													:color="$_trnSctTabLyt_styleSectionTabActionButtonColor"
																													:dark="$_trnSctTabLyt_styleSectionTabActionButtonDark"
																													:depressed="$_trnSctTabLyt_styleSectionTabActionButtonDepressed"
																													:elevation="$_trnSctTabLyt_styleSectionTabActionButtonElevation"
																													:large="$_trnSctTabLyt_styleSectionTabActionButtonLarge"
																													:light="$_trnSctTabLyt_styleSectionTabActionButtonLight"
																													:outlined="$_trnSctTabLyt_styleSectionTabActionButtonOutlined"
																													:rounded="$_trnSctTabLyt_styleSectionTabActionButtonRounded"
																													:small="$_trnSctTabLyt_styleSectionTabActionButtonSmall"
																													:text="$_trnSctTabLyt_styleSectionTabActionButtonFlat"
																													@click="openLink(actionButtonVals.link)"
																													v-text="$_trnSctTabLyt_langContentTitle(actionButtonVals)" />
																										</v-col>
																									</template>
																								</v-row>
																							</v-card-actions>
																						</v-col>
																					</v-row>
																				</template>
																			</v-col>
																		</template>
																	</v-row>
																	<v-row no-gutters>
																		<v-col>
																			<template v-if="$_trnSctTabLyt_checkSectionStatus(sectionKey, 'finished')">
																				<v-row class="mb-3" align="center" justify="center">
																					<v-col cols="auto">
																						<span	class="caption"
																								v-html="$_trnSctTabLyt_langSectionTabCompletedSection" />
																					</v-col>
																				</v-row>
																			</template>
																			<template v-else>
																				<template v-if="isObject(sectionVals.openTest)">
																					<v-card-actions>
																						<v-row no-gutters>
																							<v-col>
																								<v-row align="center" justify="center">
																									<v-col>
																										<v-btn	class="customVBtn"
																												:block="$_trnSctTabLyt_styleSectionTabOpenTestButtonBlock"
																												:color="$_trnSctTabLyt_styleSectionTabOpenTestButtonColor"
																												:dark="$_trnSctTabLyt_styleSectionTabOpenTestButtonDark"
																												:depressed="$_trnSctTabLyt_styleSectionTabOpenTestButtonDepressed"
																												:elevation="$_trnSctTabLyt_styleSectionTabOpenTestButtonElevation"
																												:large="$_trnSctTabLyt_styleSectionTabOpenTestButtonLarge"
																												:light="$_trnSctTabLyt_styleSectionTabOpenTestButtonLight"
																												:outlined="$_trnSctTabLyt_styleSectionTabOpenTestButtonOutlined"
																												:rounded="$_trnSctTabLyt_styleSectionTabOpenTestButtonRounded"
																												:small="$_trnSctTabLyt_styleSectionTabOpenTestButtonSmall"
																												:text="$_trnSctTabLyt_styleSectionTabOpenTestButtonFlat"
																												@click="$_trnSctTabLyt_openTest(sectionKey, sectionVals.openTest.link)"
																												v-text="$_trnSctTabLyt_langContentOpenTestTitle(sectionVals)" />
																									</v-col>
																								</v-row>
																							</v-col>
																						</v-row>
																					</v-card-actions>
																				</template>
																				<template v-if="!isFalse(sectionVals.completeSection)">
																					<v-card-actions>
																						<v-row dense>
																							<v-col>
																								<v-checkbox
																										:readonly="!isEmpty(sectionVals.video)"
																										:label="$_trnSctTabLyt_langContentCompleteSection(sectionVals)"
																										@change="$_trnSctTabLyt_completeSection(sectionKey)" />
																							</v-col>
																						</v-row>
																					</v-card-actions>
																				</template>
																			</template>
																		</v-col>
																	</v-row>
																</v-card>
															</v-sheet>
														</v-col>
													</v-row>
													<v-row>
														<v-col>
															<v-card	class="customVCard"
																	color="transparent"
																	flat>
																<v-card-actions>
																	<v-row dense>
																		<v-col cols="12" md="6">
																			<!-- previouse section -->
																			<v-btn	class="customVBtn"

																					:disabled="$_trnSctTabLyt_checkSectionIsFirst(sectionKey)"

																					:block="$_trnSctTabLyt_styleSectionTabNavigationButtonBlock"
																					:color="$_trnSctTabLyt_styleSectionTabNavigationButtonColor"
																					:dark="$_trnSctTabLyt_checkSectionIsFirst(sectionKey) ? $_trnSctTabLyt_stateAppIsDarkTheme : $_trnSctTabLyt_styleSectionTabNavigationButtonDark"
																					:depressed="$_trnSctTabLyt_styleSectionTabNavigationButtonDepressed"
																					:elevation="$_trnSctTabLyt_styleSectionTabNavigationButtonElevation"
																					:large="$_trnSctTabLyt_styleSectionTabNavigationButtonLarge"
																					:light="$_trnSctTabLyt_styleSectionTabNavigationButtonLight"
																					:outlined="$_trnSctTabLyt_styleSectionTabNavigationButtonOutlined"
																					:rounded="$_trnSctTabLyt_styleSectionTabNavigationButtonRounded"
																					:small="$_trnSctTabLyt_styleSectionTabNavigationButtonSmall"
																					:text="$_trnSctTabLyt_styleSectionTabNavigationButtonFlat"
																					@click="$_trnSctTabLyt_previousSection(sectionIndex)"
																					v-text="$_trnSctTabLyt_langSectionTabPreviousSection" />
																		</v-col>
																		<v-col cols="12" md="6">
																			<!-- back to course -->
																			<template v-if="$_trnSctTabLyt_checkSectionIsLast(sectionKey)">
																				<v-btn	class="customVBtn"
																						:block="$_trnSctTabLyt_styleSectionTabNavigationButtonBlock"
																						:color="$_trnSctTabLyt_styleSectionTabNavigationButtonColor"
																						:dark="$_trnSctTabLyt_styleSectionTabNavigationButtonDark"
																						:depressed="$_trnSctTabLyt_styleSectionTabNavigationButtonDepressed"
																						:elevation="$_trnSctTabLyt_styleSectionTabNavigationButtonElevation"
																						:large="$_trnSctTabLyt_styleSectionTabNavigationButtonLarge"
																						:light="$_trnSctTabLyt_styleSectionTabNavigationButtonLight"
																						:outlined="$_trnSctTabLyt_styleSectionTabNavigationButtonOutlined"
																						:rounded="$_trnSctTabLyt_styleSectionTabNavigationButtonRounded"
																						:small="$_trnSctTabLyt_styleSectionTabNavigationButtonSmall"
																						:text="$_trnSctTabLyt_styleSectionTabNavigationButtonFlat"
																						@click="$_trnSctTabLyt_backToCourse()"
																						v-text="$_trnSctTabLyt_langSectionTabBackToCourse" />
																			</template>
																			<!-- next section -->
																			<template v-else>
																				<v-btn	class="customVBtn"

																						:disabled="!$_trnSctTabLyt_checkSectionStatus(sectionKey, 'finished') || !$_trnSctTabLyt_checkNextSectionStatus(sectionKey)"
																				
																						:block="$_trnSctTabLyt_styleSectionTabNavigationButtonBlock"
																						:color="$_trnSctTabLyt_styleSectionTabNavigationButtonColor"
																						:dark="!$_trnSctTabLyt_checkSectionStatus(sectionKey, 'finished') || !$_trnSctTabLyt_checkNextSectionStatus(sectionKey) ? $_trnSctTabLyt_stateAppIsDarkTheme : $_trnSctTabLyt_styleSectionTabNavigationButtonDark"
																						:depressed="$_trnSctTabLyt_styleSectionTabNavigationButtonDepressed"
																						:elevation="$_trnSctTabLyt_styleSectionTabNavigationButtonElevation"
																						:large="$_trnSctTabLyt_styleSectionTabNavigationButtonLarge"
																						:light="$_trnSctTabLyt_styleSectionTabNavigationButtonLight"
																						:outlined="$_trnSctTabLyt_styleSectionTabNavigationButtonOutlined"
																						:rounded="$_trnSctTabLyt_styleSectionTabNavigationButtonRounded"
																						:small="$_trnSctTabLyt_styleSectionTabNavigationButtonSmall"
																						:text="$_trnSctTabLyt_styleSectionTabNavigationButtonFlat"
																						@click="$_trnSctTabLyt_nextSection(sectionIndex)"
																						v-text="$_trnSctTabLyt_langSectionTabNextSection" />
																			</template>
																		</v-col>
																	</v-row>
																</v-card-actions>
															</v-card>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-tab-item>
									</template>
								</v-tabs-items>
							</v-col>
							<v-spacer />
						</template>
						<template v-else>
							<v-row	class="customVRow">
								<v-col cols="12" class="center">
									<progress-circular />
								</v-col>
							</v-row>
						</template>
					</v-row>
				</v-col>
			</v-row>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'TrainingSectionTabLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				sectionNumber_: 0,
				sectionTitle_: '',

				initialized_: false,
				onLoading_: false
			}
		},
		computed: {
			// params
			$_trnSctTabLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_trnSctTabLyt_paramsCourseCode() {
				const self_ = this;
				const params_ = self_.$_trnSctTabLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.courseCode
			},
			$_trnSctTabLyt_paramsModuleCode() {
				const self_ = this;
				const params_ = self_.$_trnSctTabLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.moduleCode
			},
			// current user
			$_trnSctTabLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_trnSctTabLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_trnSctTabLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_trnSctTabLyt_stateTrainings() {
				const self_ = this;
				return self_.getTrainingsState()
			},
			$_trnSctTabLyt_stateTrainingsCourse() {
				const self_ = this;
				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				return self_.getTrainingsState(courseCode_)
			},
			$_trnSctTabLyt_stateTrainingsCourseModules() {
				const self_ = this;
				const course_ = self_.$_trnSctTabLyt_stateTrainingsCourse;
				if(self_.isEmpty(course_)) { return null }
				return course_.modules
			},
			$_trnSctTabLyt_stateTrainingsModule() {
				const self_ = this;
				const modules_ = self_.$_trnSctTabLyt_stateTrainingsCourseModules;
				if(self_.isEmpty(modules_)) { return {} }
				return modules_[self_.$_trnSctTabLyt_paramsModuleCode]
			},
			$_trnSctTabLyt_stateTrainingsModuleSections() {
				const self_ = this;
				const module_ = self_.$_trnSctTabLyt_stateTrainingsModule;
				if(self_.isEmpty(module_)) { return null }
				return module_.sections
			},
			// lang
			$_trnSctTabLyt_langSectionTabPageTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'sectionTabPageTitle')
				return self_.getLangsVal(lang_)
			},
			$_trnSctTabLyt_langSectionTabPageSubTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'sectionTabPageSubTitle')
				return self_.getLangsVal(lang_)
			},
			$_trnSctTabLyt_langSectionTabCompletedSection() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'sectionTabCompletedSection')
				return self_.getLangsVal(lang_)
			},
			$_trnSctTabLyt_langSectionTabPreviousSection() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'sectionTabPreviousSection')
				return self_.getLangsVal(lang_)
			},
			$_trnSctTabLyt_langSectionTabNextSection() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'sectionTabNextSection')
				return self_.getLangsVal(lang_)
			},
			$_trnSctTabLyt_langSectionTabBackToCourse() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'sectionTabBackToCourse')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_trnSctTabLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const title_ = contentVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_trnSctTabLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const text_ = contentVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			$_trnSctTabLyt_langContentSectionTitle() {
				const self_ = this;
				return contentVals => {
					const sectionTitle_ = contentVals.sectionTitle;
					if(self_.isFalse(sectionTitle_)) { return null }
					return self_.getLangsVal(sectionTitle_)
				}
			},
			$_trnSctTabLyt_langContentCompleteSection() {
				const self_ = this;
				return contentVals => {
					const completeSection_ = contentVals.completeSection;
					if(self_.isFalse(completeSection_)) { return null }
					return self_.getLangsVal(completeSection_)
				}
			},
			$_trnSctTabLyt_langContentOpenTestTitle() {
				const self_ = this;
				return contentVals => {
					const openTest_ = contentVals.openTest;
					if(self_.isEmpty(openTest_)) { return null }
					return self_.getLangsVal(openTest_.title)
				}
			},
			// link
			// (content)
			$_trnSctTabLyt_linkContentOpenTest() {
				const self_ = this;
				return contentVals => {
					const openTest_ = contentVals.openTest;
					if(self_.isEmpty(openTest_)) { return null }
					return openTest_.link
				}
			},
			// style
			$_trnSctTabLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_trnSctTabLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_trnSctTabLyt_stylePageLayout();
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_trnSctTabLyt_styleSectionTabHeaderSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sectionTabHeaderSheet')
			},
			$_trnSctTabLyt_styleSectionTabHeaderSheetColor() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_trnSctTabLyt_styleSectionTabHeaderSheetDark() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_trnSctTabLyt_styleSectionTabHeaderSheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_trnSctTabLyt_styleSectionTabHeaderSheetLight() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabHeaderSheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_trnSctTabLyt_styleSectionTabBodySheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sectionTabBodySheet')
			},
			$_trnSctTabLyt_styleSectionTabBodySheetColor() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.color)
			},
			$_trnSctTabLyt_styleSectionTabBodySheetDark() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.dark)
			},
			$_trnSctTabLyt_styleSectionTabBodySheetElevation() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.elevation)
			},
			$_trnSctTabLyt_styleSectionTabBodySheetLight() {
				const self_ = this;
				const sheet_ = self_.$_trnSctTabLyt_styleSectionTabBodySheet;
				if(self_.isFalse(sheet_)) { return null }
				return self_.getStylesVal(sheet_.light)
			},
			$_trnSctTabLyt_styleSectionTabActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sectionTabActionButton')
			},
			$_trnSctTabLyt_styleSectionTabActionButtonBlock() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonColor() {
				const self_ = this;
				const button_ =self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonDark() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonElevation() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonFlat() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonLarge() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonLight() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonRounded() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_trnSctTabLyt_styleSectionTabActionButtonSmall() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sectionTabOpenTestButton')
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonBlock() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonColor() {
				const self_ = this;
				const button_ =self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonDark() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonElevation() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonFlat() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonLarge() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonLight() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonRounded() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_trnSctTabLyt_styleSectionTabOpenTestButtonSmall() {
				const self_ = this;
				const button_ = self_.$_trnSctTabLyt_styleSectionTabOpenTestButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sectionTabNavigationButton')
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonBlock() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.block)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonColor() {
				const self_ = this;
				const navigationButton_ =self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.color)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonDark() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.dark)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonDepressed() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.depressed)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonElevation() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.elevation)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonFlat() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.flat)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonLarge() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.large)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonLight() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.light)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonOutlined() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.outlined)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonRounded() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.rounded)
			},
			$_trnSctTabLyt_styleSectionTabNavigationButtonSmall() {
				const self_ = this;
				const navigationButton_ = self_.$_trnSctTabLyt_styleSectionTabNavigationButton;
				if(self_.isFalse(navigationButton_)) { return null }
				return self_.getStylesVal(navigationButton_.small)
			},
			$_trnSctTabLyt_styleSectionTabTabs() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'sectionTabTabs')
			},
			$_trnSctTabLyt_styleSectionTabTabsBackgroundColor() {
				const self_ = this;
				const tabs_ = self_.$_trnSctTabLyt_styleSectionTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.backgroundColor)
			},
			$_trnSctTabLyt_styleSectionTabTabsColor() {
				const self_ = this;
				const tabs_ = self_.$_trnSctTabLyt_styleSectionTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.color)
			},
			$_trnSctTabLyt_styleSectionTabTabsDark() {
				const self_ = this;
				const tabs_ = self_.$_trnSctTabLyt_styleSectionTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.dark)
			},
			$_trnSctTabLyt_styleSectionTabTabsHideSlider() {
				const self_ = this;
				const tabs_ = self_.$_trnSctTabLyt_styleSectionTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.hideSlider)
			},
			$_trnSctTabLyt_styleSectionTabTabsLight() {
				const self_ = this;
				const tabs_ = self_.$_trnSctTabLyt_styleSectionTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.light)
			},
			$_trnSctTabLyt_styleSectionTabTabsSliderColor() {
				const self_ = this;
				const tabs_ = self_.$_trnSctTabLyt_styleSectionTabTabs;
				if(self_.isFalse(tabs_)) { return null }
				return self_.getStylesVal(tabs_.sliderColor)
			},
			$_trnSctTabLyt_styleTab() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'tab')
			},
			$_trnSctTabLyt_styleTabDark() {
				const self_ = this;
				const tab_ = self_.$_trnSctTabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.dark)
			},
			$_trnSctTabLyt_styleTabLight() {
				const self_ = this;
				const tab_ = self_.$_trnSctTabLyt_styleTab;
				if(self_.isFalse(tab_)) { return null }
				return self_.getStylesVal(tab_.light)
			},
			// (content)
			$_trnSctTabLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_trnSctTabLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_trnSctTabLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			},
			$_trnSctTabLyt_styleContentBigImage() {
				return contentVals => {
					return contentVals.bigImage
				}
			},
			$_trnSctTabLyt_styleContentBigImageUrl() {
				const self_ = this;
				return contentVals => {
					const bigImage_ = self_.$_trnSctTabLyt_styleContentBigImage(contentVals)
					if(self_.isEmpty(bigImage_)) { return null }
					return self_.getStylesVal(bigImage_.url)
				}
			}
		},
		created() {
			const self_ = this;

			self_.$_trnSctTabLyt_initialize()
		},
		methods: {
			$_trnSctTabLyt_initialize() {
				const self_ = this;

				self_.initialized_ = false; 

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;
				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				Promise.resolve().then(() => {
					return self_.initializeTrainings(courseCode_)
				}).then(() => {
					return self_.initializeUser('trainingData')
				}).then(() => {
					const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode_, null)

					if(self_.isFalse(status_) || status_ == 'closed') { self_.$_trnSctTabLyt_backToCourse() }

					self_.$_trnSctTabLyt_startSection()

					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnSctTabLyt_initialize()', error)
				})
			},
			$_trnSctTabLyt_checkSectionStatus(sectionCode, status) {
				const self_ = this;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;
				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode_, sectionCode)

				let result_ = false;

				if(self_.isFalse(status)) {
					if(status_ == 'opened' || status_ == 'started' || status_ == 'finished') { result_ = true }	
				} else {
					if(status_ == status) { result_ = true }
				}

				return result_
			},
			$_trnSctTabLyt_checkNextSectionStatus(sectionCode){
				const self_ = this;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;
				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				const nextSectionCode_ = self_.getNextSectionCode(courseCode_, moduleCode_, sectionCode)

				if(self_.isFalse(nextSectionCode_)) { return false }

				const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode_, nextSectionCode_)
			
				let result_ = false;

				if(self_.isFalse(status_) || status_ == 'opened' || status_ == 'started' || status_ == 'finished') { result_ = true }

				return result_
			},
			$_trnSctTabLyt_checkPreviousSectionStatus(sectionCode, status){
				const self_ = this;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;
				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				const previousSectionCode_ = self_.getPreviousSectionCode(courseCode_, moduleCode_, sectionCode)

				if(self_.isFalse(previousSectionCode_)) { return true } // first section

				const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode_, previousSectionCode_)
			
				let result_ = false;

				if(self_.isFalse(status)) {
					if(status_ == 'opened' || status_ == 'started' || status_ == 'finished') { result_ = true }
				} else {
					if(status_ == status) { result_ = true }
				}

				return result_
			},
			$_trnSctTabLyt_startSection(sectionCode) {
				const self_ = this;

				self_.onLoading_ = true;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;

				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				if(self_.isFalse(sectionCode)) {
					sectionCode = self_.getFirstSectionCode(courseCode_, moduleCode_)
				}

				Promise.resolve().then(() => {
					const status_ = self_.getUserTrainingStatus(uid_, courseCode_, moduleCode_, sectionCode)

					if(self_.isFalse(status_) || status_ == 'closed') { self_.$_trnSctTabLyt_backToCourse() }

					if(status_ == 'opened') {
						return self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode_, sectionCode, 'started')
					} else {
						return Promise.resolve()
					}
				}).then(() => {
					return self_.initializeUser('trainingData')
				}).then(() => {
					self_.onLoading_ = false;
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnSctTabLyt_startSection()', error)
				})
			},
			$_trnSctTabLyt_completeSection(sectionCode) {
				const self_ = this;
				
				self_.onLoading_ = true;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;

				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				Promise.resolve().then(() => {
					return self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode_, sectionCode, 'finished')
				}).then(() => {
					return self_.initializeUser('trainingData')
				}).then(() => {
					self_.onLoading_ = false;

					const nextSectionCode_ = self_.getNextSectionCode(courseCode_, moduleCode_, sectionCode)
					// complete module
					if(self_.isFalse(nextSectionCode_)) {
						self_.$_trnSctTabLyt_completeModule(moduleCode_)
					}
					// start next section
					else {
						self_.$_trnSctTabLyt_startSection(nextSectionCode_)
						// custom aeon fantasy start
						self_.sectionNumber_++;
						// custom aeon fantasy end
					}
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnSctTabLyt_completeSection(' + sectionCode + ')', error)
				})
			},
			$_trnSctTabLyt_completeModule(moduleCode) {
				const self_ = this;
				
				self_.onLoading_ = true;

				const uid_ = self_.$_trnSctTabLyt_currentUserUid;

				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;

				Promise.resolve().then(() => {
					return self_.updateUserTrainingStatus(uid_, courseCode_, moduleCode, null, 'finished')
				}).then(() => {
					return self_.initializeUser('trainingData')
				}).then(() => {
					self_.onLoading_ = false;
					// custom aeon fantasy start
					self_.$_trnSctTabLyt_backToCourse()
					// custom aeon fantasy end
				}).catch(error => {
/* error */			self_.logError('Error', '$_trnSctTabLyt_completeModule(' + moduleCode + ')', error)
				})
			},
			$_trnSctTabLyt_selectSection(sectionCode, sectionVals, sectionIndex) {
				const self_ = this;
				self_.sectionNumber_ = sectionIndex;
				self_.sectionTitle_ = self_.getLangsVal(sectionVals.title)
			},
			$_trnSctTabLyt_previousSection(index) {
				const self_ = this;
				self_.sectionNumber_ = index - 1;
			},
			$_trnSctTabLyt_nextSection(index) {
				const self_ = this;
				self_.sectionNumber_ = index + 1;
			},
			$_trnSctTabLyt_backToCourse() {
				const self_ = this;
				const router_ = self_.$router;
				router_.push({
					name: 'training',
					params: {
						courseCode: self_.$_trnSctTabLyt_paramsCourseCode
					}
				})
			},
			$_trnSctTabLyt_checkSectionIsFirst(sectionCode) {
				const self_ = this;

				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				const firstSectionCode_ = self_.getFirstSectionCode(courseCode_, moduleCode_)
				return firstSectionCode_ == sectionCode
			},
			$_trnSctTabLyt_checkSectionIsLast(sectionCode) {
				const self_ = this;

				const courseCode_ = self_.$_trnSctTabLyt_paramsCourseCode;
				const moduleCode_ = self_.$_trnSctTabLyt_paramsModuleCode;

				const lastSectionCode_ = self_.getLastSectionCode(courseCode_, moduleCode_)
				return lastSectionCode_ == sectionCode
			},
			$_trnSctTabLyt_openTest(sectionCode, link) {
				const self_ = this;

				link.to.params.trainingCourseCode = self_.$_trnSctTabLyt_paramsCourseCode;
				link.to.params.trainingModuleCode = self_.$_trnSctTabLyt_paramsModuleCode;
				link.to.params.trainingSectionCode = sectionCode;

				self_.openLink(link)
			}
		}
	}
</script>

<style scoped>
	.pretty_ {
		border: none;
		color: #ff5252;
	}
	.row_ {
		height: 100%;
	}
</style>